<!-- Hero Start -->
<section class="bg-half-170 d-table w-100" id="home"
         style="background: url('assets/3r/sri-lanka-witness-the-intriguing-sri-lankan-stilt-fishermen.jpg') center center;">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-8 mt-4 pt-2 mt-sm-0 pt-sm-0">
                <div class="card login_page shadow rounded border-0 ml-lg-5">
                    <div class="card-body">
                        <h5 class="card-title">You can start booking here</h5>
                        <form [formGroup]="bookForm" class="login-form">
                        <div class="row">
                            <div class="col-lg-6 col-md-12">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group position-relative">
                                            <label>Package</label>
                                            <i-feather name="map-pin" class="fea icon-sm icons"></i-feather>
                                            <input [readOnly]="true" type="text" class="form-control pl-5"  formControlName="package"
                                                   name="s"
                                                   placeholder="package">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group position-relative">
                                            <label>Days</label>
                                            <i-feather name="calendar" class="fea icon-sm icons"></i-feather>
                                            <input [readOnly]="true" type="email" class="form-control pl-5" placeholder="Number of dates"
                                                   formControlName="days"
                                                   required="">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label> From : </label>
                                            <input type="text" class="form-control" name="picker" id="checkin"
                                                   formControlName="start"
                                                   mwlFlatpickr [convertModelValue]="true">
                                        </div>
                                    </div>
                                    <!--end col-->
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label> To : </label>
                                            <input type="text" class="form-control" name="checkoutpicker"
                                                   formControlName="end"
                                                   id="checkout"
                                                   mwlFlatpickr [convertModelValue]="true">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group position-relative">
                                            <label>Children</label>
                                            <i-feather name="users" class="fea icon-sm icons"></i-feather>
                                            <input type="number" formControlName="children" class="form-control pl-5"
                                                   placeholder="children" name="Pax" type="number">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group position-relative">
                                            <label>Infants</label>
                                            <i-feather name="users" class="fea icon-sm icons"></i-feather>
                                            <input type="email" formControlName="infants" class="form-control pl-5"
                                                   placeholder="Infants" name="Pax" type="number">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group position-relative">
                                            <label>Adults</label>
                                            <i-feather name="users" class="fea icon-sm icons"></i-feather>
                                            <input type="email" formControlName="adults" class="form-control pl-5"
                                                   placeholder="Adults" name="Pax" type="number">
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-lg-6 col-md-12">

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group position-relative">
                                            <label>Name</label>
                                            <i-feather name="user" class="fea icon-sm icons"></i-feather>
                                            <input formControlName="name" type="email" class="form-control pl-5"
                                                   placeholder="Your name"
                                                   name="Your name"
                                                   required="">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group position-relative">
                                            <label> Email</label>
                                            <i-feather name="mail" class="fea icon-sm icons"></i-feather>
                                            <input formControlName="email" type="email" class="form-control pl-5"
                                                   placeholder="Email" name="email"
                                                   required="">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group position-relative">
                                            <label>Mobile</label>
                                            <i-feather name="phone" class="fea icon-sm icons"></i-feather>
                                            <input formControlName="mobile" type="email" class="form-control pl-5"
                                                   placeholder="Mobile number"
                                                   name="Mobile number"
                                                   required="">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group position-relative">
                                            <label>Country</label>
                                            <i-feather name="globe" class="fea icon-sm icons"></i-feather>
                                            <select formControlName="cont" type="email" class="form-control pl-5"
                                                   placeholder="Country" >

                                                <option *ngFor="let c of country" value="{{c}}">{{c}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <!--                                            <div class="col-md-6">-->
                                    <!--                                                <div class="form-group">-->
                                    <!--                                                    <label> Check in : </label>-->
                                    <!--                                                    <input type="text" class="form-control" name="picker" id="checkin"-->
                                    <!--                                                           [(ngModel)]="checkin"-->
                                    <!--                                                           mwlFlatpickr [convertModelValue]="true">-->
                                    <!--                                                </div>-->
                                    <!--                                            </div>-->
                                    <!--                                            &lt;!&ndash;end col&ndash;&gt;-->

                                    <!--                                            <div class="col-md-6">-->
                                    <!--                                                <div class="form-group">-->
                                    <!--                                                    <label> Check out : </label>-->
                                    <!--                                                    <input type="text" class="form-control" name="checkoutpicker" id="checkout"-->
                                    <!--                                                           [(ngModel)]="checkout"-->
                                    <!--                                                           mwlFlatpickr [convertModelValue]="true">-->
                                    <!--                                                </div>-->
                                    <!--                                            </div>-->
                                    <!--end col-->

                                    <!--                                            <div class="col-md-12">-->
                                    <!--                                                <div class="form-group">-->
                                    <!--                                                    <div class="custom-control custom-checkbox">-->
                                    <!--                                                        <input type="checkbox" class="custom-control-input" id="customCheck1">-->
                                    <!--                                                        <label class="custom-control-label" for="customCheck1">I Accept <a href="#"-->
                                    <!--                                                                                                                           class="text-primary">Terms-->
                                    <!--                                                            And Condition</a></label>-->
                                    <!--                                                    </div>-->
                                    <!--                                                </div>-->
                                    <!--                                            </div>-->
                                    <div class="col-md-12">
                                        <button class="btn btn-success w-100" (click)="saveBooking()">Book Now</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<a href="javascript: void(0);" class="btn btn-icon btn-soft-primary back-to-top" id="back-to-top"
   [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<notifier-container></notifier-container>
